import React from 'react'
import MediaNews from './child/MediaNews'



const DashBoardLayerTwo = () => {
  return (
    <section className="row gy-4">

     

      {/* RevenueGrowthOne */}
      <MediaNews />

      
    </section>

  )
}

export default DashBoardLayerTwo